import React from 'react';
import { Button } from 'react-bootstrap';

const SmallButton = ({ children, style = {}, ...props }) => {
  return (
    <Button size="sm" style={{ ...styleLocal, ...style }} {...props}>
      {children}
    </Button>
  );
};

const styleLocal = {
  padding: '0px 5px',
  fontSize: 13
};

export default SmallButton;
